import React from 'react';
import {
    Table as TableMaterial,
    TableHead,
    TableBody,
    TableRow,
    Paper,
    Checkbox
} from '@mui/material';

import {
    Text,
    StyledTableCell,
    StyledTableRow,
    StyledTableContainer
} from '../styles';

export const UsuariosTable = ({
    tableData,
    onEditUser,
    handleUserCheckbox,
    verifyCheckboxDefaultValue
}) => {
    return (
        <StyledTableContainer component={Paper}>
            <TableMaterial
                aria-label="Tabela de usuários"
                stickyHeader
                style={{ tableLayout: 'fixed' }}
            >
                <TableHead>
                    <TableRow>
                        <StyledTableCell style={{ width: '35%' }}>
                            <Text>Email</Text>
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '20%' }}>
                            <Text>CPF</Text>
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '15%' }}>
                            <Text>Status</Text>
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '15%' }}>
                            <Text>Ações</Text>
                        </StyledTableCell>
                        <StyledTableCell style={{ width: '15%' }} />
                    </TableRow>
                </TableHead>

                <TableBody>
                    {tableData.map((user) => (
                        <StyledTableRow key={user.idUsuario}>
                            <StyledTableCell>
                                <Text>{user.dsLogin}</Text>
                            </StyledTableCell>
                            <StyledTableCell>
                                <Text>{user.dsCpfCnpj || '-'}</Text>
                            </StyledTableCell>
                            <StyledTableCell>
                                <Text
                                    style={{
                                        color: user.fgAtivo ? 'green' : 'red'
                                    }}
                                >
                                    {user.fgAtivo ? 'Ativo' : 'Inativo'}
                                </Text>
                            </StyledTableCell>
                            <StyledTableCell>
                                <Text
                                    style={{
                                        color: '#085ccc',
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => onEditUser(user)}
                                >
                                    Editar
                                </Text>
                            </StyledTableCell>
                            <StyledTableCell>
                                <Checkbox
                                    color="default"
                                    onChange={() => {
                                        handleUserCheckbox(user);
                                    }}
                                    checked={verifyCheckboxDefaultValue(user)}
                                />
                            </StyledTableCell>
                        </StyledTableRow>
                    ))}
                </TableBody>
            </TableMaterial>
        </StyledTableContainer>
    );
};
